import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import Button from "~/components/Button";
import { Container } from "~/components/Container";
import Text from "~/components/Text";
import useUtmParams from "~/hooks/useUtmParams";
import Trans from "~/types/translationKeys";
import { openModal } from "../ApplicationFormModal/ApplicationFormModal";
import styles from "./ReferralTiers.module.scss";

function ReferralTiers() {
  const { t } = useTranslation();
  const utmParams = useUtmParams();

  return (
    <section id="program-tiers" className={styles.program_tiers}>
      <Container className={styles.container}>
        <div className={styles.title_wrapper}>
          <Text
            type={"headline-4"}
            align={"center"}
            data-aos="fade-up"
            className={styles.title}
          >
            {t(Trans.referral_program_tiers)}
          </Text>

          <Text type={"body-1"} align={"center"} data-aos="fade-up">
            {t(Trans.find_the_perfect_fit_for_your_goals)}
          </Text>
        </div>

        <div className={styles.tiers_wrapper}>
          <div className={classNames(styles.tier, styles.advocate)}>
            <div className={styles.info_wrapper}>
              <div className={styles.thumbnail}>
                <Image
                  src={"svgs/affiliate_advocate.svg"}
                  alt={"Advocate"}
                  width={48}
                  height={48}
                />
                <Text type={"headline-4"} className={styles.tier_title}>
                  {t(Trans.advocate_tier_title)}
                </Text>
                <Text type={"title-2"}>{t(Trans.advocate_tier_subtitle)}</Text>
              </div>

              <Text type={"body-2"} className={styles.tier_description}>
                {t(Trans.advocate_tier_description)}
              </Text>

              <Link
                type="outline"
                href={{
                  pathname: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in`,
                  query: { ...utmParams },
                }}
                target="_blank"
              >
                <Button className={styles.button} type="outline">
                  {t(Trans.advocate_tier_button)}
                </Button>
              </Link>
            </div>

            <hr className={styles.divider} />

            <div className={styles.list_wrapper}>
              <div className={styles.list_item}>
                <Image
                  src={"/svgs/affiliate_checkmark_blue.svg"}
                  alt={"checkmark"}
                  width={24}
                  height={24}
                  style={{ objectFit: "contain" }}
                />
                <div>
                  <Text type={"title-2"}>
                    {t(Trans.advocate_benefit_1_title)}
                  </Text>
                  <p className={styles.list_description}>
                    {t(Trans.advocate_benefit_1_description)}
                  </p>
                </div>
              </div>

              <hr className={styles.list_item_divider} />

              <div className={styles.list_item}>
                <Image
                  src={"/svgs/affiliate_checkmark_blue.svg"}
                  alt={"checkmark"}
                  width={24}
                  height={24}
                  style={{ objectFit: "contain" }}
                />
                <div>
                  <Text type={"title-2"}>
                    {t(Trans.advocate_benefit_2_title)}
                  </Text>
                  <p className={styles.list_description}>
                    {t(Trans.advocate_benefit_2_description)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={classNames(styles.tier, styles.business_partner)}>
            <div className={styles.info_wrapper}>
              <div className={styles.thumbnail}>
                <Image
                  src={"svgs/affiliate_business_partner.svg"}
                  alt={"Advocate"}
                  width={48}
                  height={48}
                />
                <Text type={"headline-4"} className={styles.tier_title}>
                  {t(Trans.partner_tier_title)}
                </Text>
                <Text type={"title-2"}>{t(Trans.partner_tier_subtitle)}</Text>
              </div>

              <Text type={"body-2"} className={styles.tier_description}>
                {t(Trans.partner_tier_description)}
              </Text>

              <Button className={styles.button} onClick={() => openModal()}>
                {t(Trans.partner_tier_button)}
              </Button>
            </div>

            <hr className={styles.divider} />

            <div className={styles.list_wrapper}>
              <div className={styles.list_item}>
                <Image
                  src={"/svgs/affiliate_checkmark_orange.svg"}
                  alt={"checkmark"}
                  width={24}
                  height={24}
                  style={{ objectFit: "contain" }}
                />
                <div>
                  <Text type={"title-2"}>
                    {t(Trans.partner_benefit_1_title)}
                  </Text>
                  <p className={styles.list_description}>
                    {t(Trans.partner_benefit_1_description)}
                  </p>
                </div>
              </div>

              <hr className={styles.list_item_divider} />

              <div className={styles.list_item}>
                <Image
                  src={"/svgs/affiliate_checkmark_orange.svg"}
                  alt={"checkmark"}
                  width={24}
                  height={24}
                  style={{ objectFit: "contain" }}
                />
                <div>
                  <Text type={"title-2"}>
                    {t(Trans.partner_benefit_2_title)}
                  </Text>
                  <p className={styles.list_description}>
                    {t(Trans.partner_benefit_2_description)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default ReferralTiers;
